var ___EXPOSE_LOADER_IMPORT___ = require("-!./config.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["bootstrap"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["bootstrap"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
